import useReveal from "../hooks/useReveal";
import { Shield, Leaf, Globe2 } from "lucide-react";

const PILLARS = [
  {
    icon: Shield,
    title: "Sovereign Infrastructure",
    body: "A secure, Australian-based computing platform insulated from foreign jurisdictions — a digital safe-harbor for sensitive workloads.",
    tag: "Tier-1 / Sovereign",
  },
  {
    icon: Leaf,
    title: "Zero-Carbon Computing",
    body: "Powered exclusively by 100% renewable grid infrastructure. Industrial-scale AI without industrial-scale emissions.",
    tag: "100% Renewable",
  },
  {
    icon: Globe2,
    title: "Regional Leadership",
    body: "Positioning Australia as the trusted digital services provider for the Indo-Pacific — collaborative, resilient, regional.",
    tag: "Indo-Pacific",
  },
];

export default function Pillars() {
  const ref = useReveal();
  return (
    <section
      ref={ref}
      id="pillars"
      data-testid="pillars-section"
      className="relative py-28 md:py-40 border-t border-[var(--border-faint)]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-16 reveal">
          <div className="max-w-2xl">
            <div className="eyebrow mb-4">— 01 / Pillars</div>
            <h2 className="font-display text-3xl md:text-5xl text-[var(--text)] leading-[1.05] tracking-tight">
              Built on three immovable principles.
            </h2>
          </div>
          <div className="font-mono text-xs text-[var(--text-40)] tracking-wider md:max-w-xs">
            Three pillars, one mission — to keep Australia&apos;s most
            critical resource of the 21st century at home.
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-[var(--border-subtle)] border border-[var(--border-subtle)]">
          {PILLARS.map((p, i) => {
            const Icon = p.icon;
            return (
              <div
                key={p.title}
                data-testid={`pillar-card-${i}`}
                className="reveal group p-8 md:p-10 transition-colors duration-500 relative"
                style={{ background: "var(--surface)", transitionDelay: `${i * 80}ms` }}
              >
                <div className="flex items-start justify-between mb-10">
                  <div className="w-12 h-12 border border-[var(--color-lime-deep)]/40 dark:border-[var(--color-lime)]/40 flex items-center justify-center group-hover:border-[var(--color-yellow-deep)] dark:group-hover:border-[var(--color-yellow)] transition-colors">
                    <Icon
                      size={20}
                      className="text-[var(--color-lime-deep)] dark:text-[var(--color-lime)] group-hover:text-[var(--color-yellow-deep)] dark:group-hover:text-[var(--color-yellow)] transition-colors"
                      strokeWidth={1.5}
                    />
                  </div>
                  <span className="font-mono text-[10px] tracking-[0.2em] uppercase text-[var(--text-40)]">
                    0{i + 1}
                  </span>
                </div>

                <h3 className="font-display text-[var(--text)] text-2xl md:text-[28px] leading-tight mb-5 tracking-tight">
                  {p.title}
                </h3>
                <p className="text-[var(--text-65)] text-[15px] leading-relaxed mb-8">
                  {p.body}
                </p>
                <div className="font-mono text-[10px] tracking-[0.25em] uppercase text-[var(--color-teal)] border-t border-[var(--border-subtle)] pt-4">
                  {p.tag}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
